import { render, staticRenderFns } from "./cloumnItem.vue?vue&type=template&id=7fc7942c&scoped=true"
import script from "./cloumnItem.vue?vue&type=script&lang=js"
export * from "./cloumnItem.vue?vue&type=script&lang=js"
import style0 from "./cloumnItem.vue?vue&type=style&index=0&id=7fc7942c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc7942c",
  null
  
)

export default component.exports